import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'common/assets/css/custom-datepicker.css';
import calenderIcon from 'common/assets/img/Calender.png';
import { Box, Image } from "@chakra-ui/react";
import { constant } from "common/constant";

const CustomDatePicker = (props) => {
    const { startDate = null, setStartDate,fullWidth, time = false } = props; 
    const datePickerRef = useRef(null); 

    const handleIconClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setOpen(true); 
        }
    };

    return (
        <Box 
        className={`${fullWidth ? 'custom-datepickerFullWidth' : 'custom-datepicker'}`}
        >
            <DatePicker
                showTimeSelect={time}
                showTimeSelectOnly={time}
                timeIntervals={15}
                timeFormat="HH:mm"
                dateFormat={time ? "HH:mm" : "dd-MM-yyyy"} 
                placeholderText={time ? constant.selectTime : constant.selectDate}
                ref={datePickerRef}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                customInput={<input placeholder={constant.selectDate} className="custom-datepickerInput" />}
            />
            {!time &&
                <Box className="custom-datepicker-calendar-icon" onClick={handleIconClick}>
                    <Image src={calenderIcon} h={'16px'} w={'16px'} />
                </Box>
            }
        </Box>
    );
}

export default CustomDatePicker;